import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Attendance } from '../../models/attendance.school.model';
import { Group } from '../../models/group.model';
import { SchoolMemberType } from '../../models/member.school.model';

export const getAttendances = createAction(
  '[School Attendance] Get Attendances',
  props<{
    groupId: string;
    userMemberType?: SchoolMemberType;
    lastRecord?: Timestamp;
  }>(),
);

export const addAttendancesToStore = createAction(
  '[School Attendance] Add Attendances to store',
  props<{ attendances: Attendance[] }>(),
);
export const addAttendanceToStore = createAction(
  '[School Attendance] Add Attendance to store',
  props<{ attendance: Attendance }>(),
);

export const getAttendance = createAction(
  '[School Attendance] Get attendance',
  props<{ memberId: string }>(),
);

export const getAttendancesFailure = createAction(
  '[School Attendance] Get Attendances Failed',
  props<{ error: AppExceptionModel }>(),
);

// Update Attendance Actions
export const update = createAction(
  '[School Attendance] Update',
  props<{ groupId: string; studentId: string; attendance: Attendance }>(),
);
export const updateFailure = createAction(
  '[School Attendance] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction('[School Attendance] Update Success');

// Delete Attendance Actions
export const deleteAction = createAction(
  '[School Attendance] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[School Attendance] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Attendance] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Attendance] Clear from store',
  props<{ id: string }>(),
);

export const getAttendanceStats = createAction(
  '[School Attendance] Get Attendance Statistics',
  props<{ groupId: string }>(),
);

export const getAttendanceStatsDone = createAction(
  '[School Attendance] Get Attendance Statistics Done',
  props<{ group: Group }>(),
);
export const getAttendanceStatsFailure = createAction(
  '[School Attendance] Attendance Statistics Failure',
  props<{ error: any }>(),
);

export const clear = createAction('[School Attendance] Clear Attendances');
